import { use as i18nUse } from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './messages/en.json';

import { registerLocale as registerCountriesLocale } from 'i18n-iso-countries';
import enCountries from 'i18n-iso-countries/langs/en.json';

registerCountriesLocale(enCountries);

i18nUse(initReactI18next).init({
  resources: {
    'en-GB': en,
  },
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  fallbackNS: ['common', 'errors'],
  interpolation: {
    escapeValue: false,
    defaultVariables: {
      productName: __PRODUCT_NAME__,
      companyName: __COMPANY_NAME__,
    },
  },
});
